import Vue from 'vue'
import Router from 'vue-router'
import List from '@/pages/List'
import Info from '@/pages/Info'
import Search from '@/pages/Search'
import Me from '@/pages/Me'
import Contact from '@/pages/Contact'
import Jump from '@/pages/Jump'

Vue.use(Router)

export default new Router({
  mode: 'history', // 关键：关闭 hash 模式
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      path: '/',
      name: 'List',
      component: List
    },
    {
      path: '/blog/:link',
      name: 'Info',
      component: Info
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/me',
      name: 'Me',
      component: Me
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/jump',
      name: 'Jump',
      component: Jump
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js